/**
 * Converts a SELECTED_ENTITY-style raw entity code (e.g. "FXCM_EU", "FXCMNO",
 * the `entity_code` values from countryList.json) into the locale-folder
 * segment used under public/locales/{folder}/... .
 *
 * Single source of truth for this transform (CX-51004 / CX-51021 follow-up):
 * i18n.js's backend.loadPath and countryBlocked.js's cross-entity bundle
 * fetch both import this rather than each duplicating the ternary/replace
 * logic. Kept in its own module (not in i18n.js or countryBlocked.js) so
 * countryBlocked.js can import both this and i18n.js's getBaseURL without
 * creating a circular dependency.
 */
export const entityToLocaleFolder = (rawEntity) => {
	if (!rawEntity) return null;
	return rawEntity === "FXCMNO" || rawEntity === "FXCM_NO"
		? "no"
		: String(rawEntity).toLowerCase().replace("fxcm_", "");
};

// Entity whose locale folder ships every supported language (public/locales/no/*).
export const ALL_LANGUAGES_ENTITY = "FXCMNO";

/**
 * Picks the entity whose locale folder the i18n backend should load `lang`
 * from. Used on the entity-neutral auth pages (login / forgot username /
 * forgot password), which offer every language even when the current entity
 * has no bundle for it (CX-51034). Prefers the user's own entity; otherwise
 * the all-languages entity; otherwise the first entity languageList.json
 * lists for `lang`. Falls back to `userEntity` when `lang` is unknown.
 */
export const resolveLocaleEntity = (lang, userEntity, langList) => {
	const entities = langList?.[lang]?.entity;
	if (!Array.isArray(entities) || entities.length === 0) return userEntity;
	if (entities.includes(userEntity)) return userEntity;
	if (entities.includes(ALL_LANGUAGES_ENTITY)) return ALL_LANGUAGES_ENTITY;
	return entities[0];
};
